import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  //配置企业信息 名字
  GET_EDIT,
  GET_EDIT_SUCCESS,
  GET_EDIT_ERROR
} from "@/action-types/userInfo";
import apiEdit from '../apis/pc/guidance/guidance'
import editGuidanceReducer from '../reducers/editGuidance'

reducerRegistry.register('enterPriseInfo', editGuidanceReducer)

// 企业配置
export function getEdit() {
  return {
    types: [GET_EDIT, GET_EDIT_SUCCESS, GET_EDIT_ERROR],
    callAPI: () => apiEdit.getGuidanceMessage()
  };
}
